<script setup lang="ts">
import { sanitizeInlineHtml } from "./rich-text";

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  tag: {
    type: String,
    default: "p",
  },
});

const sanitizedMessage = computed(() => sanitizeInlineHtml(props.message));
</script>

<template>
  <component :is="tag" v-bind="$attrs" v-html="sanitizedMessage" />
</template>
